mutation UpdateMatchCampaignCategory(
  $matchCampaignCategoryInput: MatchCampaignCategoryInput!
) {
  updateMatchCampaignCategory(
    input: { matchCampaignCategoryInput: $matchCampaignCategoryInput }
  ) {
    matchCampaignCategory {
      id
    }
  }
}
